module.exports = __webpack_public_path__ + "img/icon-draft2.6d5b60eb.png";